/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const PaginatedValidationWorkflowDropdownList = zod.strictObject({
    count: zod.number().optional(),
    has_next: zod.boolean().optional(),
    has_previous: zod.boolean().optional(),
    limit: zod.number().optional(),
    page: zod.number().optional().describe('The current page number'),
    pages: zod.number().optional().describe('The total number of pages'),
    results: zod
        .array(
            zod.strictObject({
                value: zod.number(),
                label: zod.string(),
            }),
        )
        .optional(),
});

export type PaginatedValidationWorkflowDropdownList = zod.input<
    typeof PaginatedValidationWorkflowDropdownList
>;
export type PaginatedValidationWorkflowDropdownListOutput = zod.output<
    typeof PaginatedValidationWorkflowDropdownList
>;
